import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { pxToRem } from 'utils/styled'

export const SContainer = styled.div`
  border: 2px solid var(--c-blue100);
  padding: ${pxToRem(28)}rem;
`
export const SImage = styled.img`
  width: ${pxToRem(80)}rem;
  height: ${pxToRem(80)}rem;
  object-fit: cover;
  border-radius: 100%;
  margin-bottom: 1rem;
`

export const SJobTitle = styled(Text)`
  font-size: ${pxToRem(14)}rem;
  margin-bottom: ${pxToRem(8)}rem;
`

export const SDescription = styled(Text)`
  font-style: italic;
  margin-bottom: 2rem;
  &:before {
    content: '“';
  }

  &:after {
    content: '”';
  }
`

export const SName = styled(Text.withComponent('strong'))`
  font-weight: 700;
  color: var(--c-gray100);
  font-size: ${pxToRem(18)}rem;
`
